import styled from 'styled-components'
import { injectModifiers } from 'ui/themes/utils'
import modifiers from 'ui/themes/modifiers'

const Img = styled.img`
  ${({ theme }) => injectModifiers(modifiers(theme))}
`

export default Img
